var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 198,
    viewBox: "0 0 199 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.3649 1.50684H99.8147C153.402 1.50684 196.845 44.9612 196.845 98.5658V99.0157C196.845 152.62 153.402 196.075 99.8147 196.075H99.3649C45.7772 196.075 2.33496 152.62 2.33496 99.0157V98.5658C2.33496 44.9612 45.7772 1.50684 99.3649 1.50684Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.151 40.2014H69.0358C52.1517 40.2014 38.416 53.9411 38.416 70.8302V126.758C38.416 143.647 52.1517 157.387 69.0358 157.387H130.151C147.035 157.387 160.771 143.647 160.771 126.758V70.8302C160.771 53.9411 147.035 40.2014 130.151 40.2014ZM49.2177 70.8302C49.2177 59.9007 58.1095 51.0063 69.0358 51.0063H130.151C141.077 51.0063 149.969 59.9007 149.969 70.8302V126.758C149.969 137.687 141.077 146.582 130.151 146.582H69.0358C58.1095 146.582 49.2177 137.687 49.2177 126.758V70.8302Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5934 127.277C115.294 127.277 128.075 114.499 128.075 98.7871C128.075 83.0747 115.301 70.2971 99.5934 70.2971C83.8856 70.2971 71.1118 83.0747 71.1118 98.7871C71.1118 114.499 83.8856 127.277 99.5934 127.277ZM99.5934 81.1089C109.343 81.1089 117.273 89.0412 117.273 98.794C117.273 108.547 109.343 116.479 99.5934 116.479C89.8435 116.479 81.9135 108.547 81.9135 98.794C81.9135 89.0412 89.8435 81.1089 99.5934 81.1089Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.712 74.9001C134.939 74.9001 138.386 71.46 138.386 67.2239C138.386 62.9877 134.946 59.5476 130.712 59.5476C126.477 59.5476 123.038 62.9877 123.038 67.2239C123.038 71.46 126.477 74.9001 130.712 74.9001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.c19e49b91579d24b1bfc29160853d8f7.svg";
export { ForwardRef as ReactComponent };